import { createSlice} from "@reduxjs/toolkit";

// Define the initial state structure
const initialState = {};

const Campaign = createSlice({
    name: "campaign",
    initialState,
    reducers: {
        // Correctly handling state update using the payload
        setCampaign: (state, action) => {
            // Directly setting the state with the action payload
            return { ...state, ...action.payload };
        },
    },
});

// Exporting the action and reducer
export const { setCampaign } = Campaign.actions;

export default Campaign.reducer;
